/* eslint-disable @typescript-eslint/no-explicit-any */
interface CustomWindow extends Window {
  [key: string]: any;
}

export const getConfig = (config: string) => {
  // Em desenvolvimento local, prioriza process.env (Create React App injeta variáveis REACT_APP_*)
  // Em produção, prioriza window (variáveis vêm do env.js)
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost';

  if (isLocalhost) {
    // Em localhost, usa process.env primeiro
    return process.env[config] || (window as CustomWindow)[config];
  }

  // Em produção, usa window primeiro (env.js)
  return (window as CustomWindow)[config] || process.env[config];
};
